import { FormattedMessage } from 'react-intl';
import React from 'react';
import Cookies from 'js-cookie';

export const RULE_FOR_EMPTY_VALUE = 'has-empty-value';

export const getStateValue = (states, byKey) => {
  return states.find((stateObject) => stateObject.key === byKey).value[0];
};

export const getStateAction = (states, byKey) => {
  return states.find((stateObject) => stateObject.key === byKey).value[1];
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getMetaDataTableValuesAsoApartment = (data) => {
  const isAvailableImmediately = isImmediatelyAvailableApartment(data);
  const showingStartDateTime = new Date(data.ap_showing_start);
  const showingInFuture = showingStartDateTime > new Date();

  return [
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_1' />,
      value: data.ap_usage_fee.replace(/\./g, ',') + '€',
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_2' />,
      value: data.ap_takeover_price.replace(/\./g, ',') + '€',
    },
    ...(isNewUnderConstruction(data)
      ? [
          {
            label: <FormattedMessage id='UNIT_VALUES_LABEL_3' />,
            value: data.unit_completion_date
              ? new Date(data.unit_completion_date)
                  .toLocaleDateString('fi-FI', {
                    year: 'numeric',
                    month: 'numeric',
                  })
                  .split('.')
                  .join('/')
              : null,
          },
        ]
      : [
          {
            label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3' />,
            value: data.ap_building_year,
          },
        ]),
    {
      label: <FormattedMessage id='APARTMENT_RENOVATED' />,
      value: data.ap_comfort_renovation_year,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_4' />,
      value: data.ap_floor + '/' + data.ap_floors,
    },
    ...(!isNewUnderConstruction(data)
      ? [
          {
            label: <FormattedMessage id='APARTMENT_VALUES_LABEL_5' />,
            value: isAvailableImmediately ? (
              <FormattedMessage id='APARTMENT_AVAILABLE_LABEL' />
            ) : data.ap_date_available ? (
              new Date(data.ap_date_available).toLocaleDateString('fi-FI')
            ) : (
              <FormattedMessage id='APARTMENT_AVAILABLE_UNKNOWN' />
            ),
          },
        ]
      : []),
    ...((showingInFuture && !isNewUnderConstruction(data)) ||
    (showingInFuture && isAvailableImmediately) ||
    (showingInFuture && isNewUnderConstruction(data))
      ? [
          {
            label: <FormattedMessage id='APARTMENT_VALUES_LABEL_6' />,
            value: data.ap_showing_date
              ? `${new Date(data.ap_showing_date).toLocaleDateString('fi-FI')}${
                  Cookies.get('pll_language') &&
                  Cookies.get('pll_language') === 'fi'
                    ? ', klo '
                    : ', at '
                }
          ${new Date(data.ap_showing_start).toLocaleTimeString('fi-FI', {
            hour: '2-digit',
            minute: '2-digit',
          })}
          `
              : null,
          },
        ]
      : []),
  ];
};

export const getMetaDataTableValuesAsoUnit = (data) => {
  const isPlanned = data.unit_is_planned == 1 ? true : false;
  const isEstimated =
    data.unit_is_completion_date_estimated == 1 ? true : false;

  if (isNewUnderConstruction(data) || (isPlanned && isEstimated)) {
    return [
      {
        label: <FormattedMessage id='UNIT_VALUES_LABEL_1' />,
        value: data.unit_avg_usage_fee.replace(/\./g, ',') + '€ / jm2',
      },
      {
        label: <FormattedMessage id='UNIT_VALUES_LABEL_2' />,
        value: data.unit_avg_initial_price.replace(/\./g, ',') + '€ / jm2',
      },
      {
        label: <FormattedMessage id='UNIT_VALUES_LABEL_3' />,
        value: data.unit_completion_date
          ? new Date(data.unit_completion_date)
              .toLocaleDateString('fi-FI', {
                year: 'numeric',
                month: 'numeric',
              })
              .split('.')
              .join('/')
          : null,
      },
    ];
  }
  return [
    {
      label: <FormattedMessage id='UNIT_VALUES_LABEL_1' />,
      value: data.unit_avg_usage_fee.replace(/\./g, ',') + '€ / jm2',
    },
    {
      label: <FormattedMessage id='UNIT_VALUES_LABEL_2' />,
      value: data.unit_avg_initial_price.replace(/\./g, ',') + '€ / jm2',
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3' />,
      value: data.unit_building_year,
    },
    {
      label: <FormattedMessage id='APARTMENT_RENOVATED' />,
      value: data.unit_comfort_renovation_year ?? null,
    },
  ];
};

export const getMetaDataTableValuesRentApartment = (data) => {
  const isAvailableImmediately = isImmediatelyAvailableApartment(data);
  const showingStartDateTime = new Date(data.ap_showing_start);
  const showingInFuture = showingStartDateTime > new Date();

  return [
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_1_RENT' />,
      value: data.ap_rent.replace(/\./g, ',') + '€',
    },
    ...(isNewUnderConstruction(data)
      ? [
          {
            label: <FormattedMessage id='UNIT_VALUES_LABEL_3' />,
            value: data.unit_completion_date
              ? new Date(data.unit_completion_date)
                  .toLocaleDateString('fi-FI', {
                    year: 'numeric',
                    month: 'numeric',
                  })
                  .split('.')
                  .join('/')
              : null,
          },
        ]
      : [
          {
            label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3' />,
            value: data.ap_building_year,
          },
        ]),
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_4' />,
      value: data.ap_floor + '/' + data.ap_floors,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_5' />,
      value: isAvailableImmediately ? (
        <FormattedMessage id='APARTMENT_AVAILABLE_LABEL' />
      ) : data.ap_date_available ? (
        new Date(data.ap_date_available).toLocaleDateString('fi-FI')
      ) : (
        <FormattedMessage id='APARTMENT_AVAILABLE_UNKNOWN' />
      ),
    },
    ...(showingInFuture
      ? [
          {
            label: <FormattedMessage id='APARTMENT_VALUES_LABEL_6' />,
            value: data.ap_showing_date
              ? `
            ${new Date(data.ap_showing_date).toLocaleDateString('fi-FI')}${
                  Cookies.get('pll_language') &&
                  Cookies.get('pll_language') == 'fi'
                    ? ', klo '
                    : ', at '
                }
            ${new Date(data.ap_showing_start).toLocaleTimeString('fi-FI', {
              hour: '2-digit',
              minute: '2-digit',
            })}
            `
              : null,
          },
        ]
      : []),
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3_RENT' />,
      value: data.ap_is_income_limited == 1 ? RULE_FOR_EMPTY_VALUE : null,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_2_RENT' />,
      value: data.ap_is_subsidized == 1 ? RULE_FOR_EMPTY_VALUE : null,
    },
  ];
};

export const getMetaDataTableValuesRentUnit = (data) => {
  return [
    ...(isNewUnderConstruction(data)
      ? [
          {
            label: <FormattedMessage id='UNIT_VALUES_LABEL_1_RENT' />,
            value: data.unit_rents_range,
          },
          {
            label: <FormattedMessage id='UNIT_VALUES_LABEL_3' />,
            value: data.unit_completion_date
              ? new Date(data.unit_completion_date)
                  .toLocaleDateString('fi-FI', {
                    year: 'numeric',
                    month: 'numeric',
                  })
                  .split('.')
                  .join('/')
              : null,
          },
        ]
      : []),
    {
      label: <FormattedMessage id='UNIT_VALUES_LABEL_1_RENT' />,
      value: data.unit_rents_range,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3' />,
      value: data.unit_building_year,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_3_RENT' />,
      value: data.ap_is_income_limited == 1 ? RULE_FOR_EMPTY_VALUE : null,
    },
    {
      label: <FormattedMessage id='APARTMENT_VALUES_LABEL_2_RENT' />,
      value: data.ap_is_subsidized == 1 ? RULE_FOR_EMPTY_VALUE : null,
    },
  ];
};

export const getAvailableStatusMessages = (data) => {
  const isNewDevelopment = data.ap_is_new_development == 1 ? true : false;
  const isBasicRenovated = data.ap_is_comfort_renovated == 1 ? true : false;
  const isPlanned = data.unit_is_planned == 1 ? true : false;
  const today = new Date();
  const isAvailableImmediately = isImmediatelyAvailableApartment(data);
  const unitCompletionDate = data.unit_completion_date
    ? new Date(data.unit_completion_date)
    : null;

  if (isNewUnderConstruction(data)) {
    return <FormattedMessage id='APARTMENT_NEW_AND_IN_CONSTRUCTION' />;
  } else if (isNewDevelopment && isAvailableImmediately) {
    return <FormattedMessage id='APARTMENT_NEW_AND_AVAILABLE' />;
  } else if (isAvailableImmediately && isBasicRenovated) {
    return <FormattedMessage id='APARTMENT_RENOVATED_AND_AVAILABLE' />;
  } else if (isAvailableImmediately) {
    return <FormattedMessage id='APARTMENT_AVAILABLE_LABEL' />;
  } else if (isPlanned && unitCompletionDate && unitCompletionDate >= today) {
    return <FormattedMessage id='APARTMENT_IS_PLANNED' />;
  } else if (isNewDevelopment) {
    return <FormattedMessage id='APARTMENT_STATUS_LABEL' />;
  } else if (isBasicRenovated) {
    return <FormattedMessage id='APARTMENT_RENOVATED' />;
  } else {
    return null;
  }
};

//Cost unit status label
export const getAvailableStatusMessagesCostUnit = (data) => {
  const isNewDevelopment = data.unit_is_new_development == 1 ? true : false;
  const isBasicRenovated = data.ap_is_comfort_renovated == 1 ? true : false;
  const isPlanned = data.unit_is_planned == 1 ? true : false;
  const today = new Date();
  const isAvailableImmediately = isImmediatelyAvailableApartment(data);
  const unitCompletionDate = data.unit_completion_date
    ? new Date(data.unit_completion_date)
    : null;

  if (isNewUnderConstruction(data)) {
    return <FormattedMessage id='APARTMENT_NEW_AND_IN_CONSTRUCTION' />;
  } else if (isNewDevelopment && isAvailableImmediately) {
    return <FormattedMessage id='APARTMENT_NEW_AND_AVAILABLE' />;
  } else if (isAvailableImmediately && isBasicRenovated) {
    return <FormattedMessage id='APARTMENT_RENOVATED_AND_AVAILABLE' />;
  } else if (isAvailableImmediately) {
    return <FormattedMessage id='APARTMENT_AVAILABLE_LABEL' />;
  } else if (isPlanned && unitCompletionDate && unitCompletionDate >= today) {
    return <FormattedMessage id='APARTMENT_IS_PLANNED' />;
  } else if (isNewDevelopment) {
    return <FormattedMessage id='APARTMENT_STATUS_LABEL' />;
  } else if (isBasicRenovated) {
    return <FormattedMessage id='APARTMENT_RENOVATED' />;
  } else {
    return null;
  }
};

export const getUnitExtraInfoMessages = (data, type) => {
  const isNewDevelopment = data.unit_is_new_development == 1 ? true : false;
  const isPlanned = data.unit_is_planned == 1 ? true : false;

  if (
    isPlanned &&
    data.unit_completion_date &&
    new Date(data.unit_completion_date) > new Date()
  ) {
    return <FormattedMessage id='EXTRA_INFO_2' />;
  }

  if (isNewDevelopment && 'rent' !== type) {
    return <FormattedMessage id='EXTRA_INFO_1' />;
  } else {
    return null;
  }
};

export const getApartmentExtraInfoMessages = (data, type) => {
  const isNewDevelopment = data.ap_is_new_development == 1 ? true : false;

  if (isNewDevelopment && 'rent' !== type) {
    return <FormattedMessage id='EXTRA_INFO_1' />;
  }

  return null;
};

export const isImmediatelyAvailableApartment = (data) => {
  const isAvailable = data.ap_is_available == 1 ? true : false;
  const today = new Date();
  const availableDate = data.ap_date_available
    ? new Date(data.ap_date_available)
    : null;
  return isAvailable && availableDate && today >= availableDate;
};

export const translateBuildingType = (buildingTypeString) => {
  // HOX! Removes ä/ö/å etc. so the translation ids need to be named without those as well.
  // e.g. LUHTIKYTVTALO
  return (
    <FormattedMessage
      id={buildingTypeString.replace(/[^\x00-\x7F]/g, '').toUpperCase()}
    />
  );
};

export const isNewUnderConstruction = (data) => {
  const isNewDevelopment = data.ap_is_new_development == 1 ? true : false;
  const isPlanned = data.unit_is_planned == 1 ? true : false;
  const today = new Date();
  const isAvailableImmediately = isImmediatelyAvailableApartment(data);
  const unitCompletionDate = data.unit_completion_date
    ? new Date(data.unit_completion_date)
    : null;

  if (
    isAvailableImmediately &&
    isNewDevelopment &&
    unitCompletionDate &&
    unitCompletionDate >= today
  ) {
    return true;
  } else if (
    isNewDevelopment &&
    unitCompletionDate &&
    unitCompletionDate >= today &&
    !isPlanned
  ) {
    return true;
  }

  return false;
};
